module.exports = __webpack_public_path__ + "static/5.1_ancient_egypt-679cd3435c66eadac00520497218578c.pdf";